// src/pages/payment/PaymentFailurePage.jsx
import { AlertCircle } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router";

export default function PaymentFailurePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-[#E5E7EB] p-8 text-center">
        <AlertCircle className="w-12 h-12 text-red-600 mx-auto mb-4" />
        <h2 className="text-xl text-[#2D323A] mb-2">Payment failed</h2>
        <p className="text-sm text-[#717182] mb-6">
          Your card was not charged. You can try again with a different payment
          method.
        </p>
        {orderId && (
          <p className="text-xs text-[#717182] mb-4">
            Reference: <span className="font-mono">{orderId}</span>
          </p>
        )}
        <button
          onClick={() => navigate("/auth/subscription")}
          className="w-full py-3 bg-[#1E6DFF] text-white rounded-xl"
        >
          Try again
        </button>
      </div>
    </div>
  );
}